import React from 'react';
import ReactDOM from 'react-dom';
import Config from './config';

require('es6-promise').polyfill();
require('./polyfill/index');
import App from './components/app';

ReactDOM.render(<App />, document.getElementById('app'));

window.resetKiosk = function () {
  if (parent && document.kvConfig.kioskMode) {
    if (parent.window.resetKiosk) {
      Config.parent.window.resetKiosk();
    }
  }
};


// WEBPACK FOOTER //
// ./src/main.js